// extracted by mini-css-extract-plugin
export default {"Learn":"Learn_Learn__bnbzP","Left":"Learn_Left__ZjZc9","Text":"Learn_Text__4JCVi"};